class CardsCarouselComponent extends HTMLElement {
  constructor() {
    super();
    this.splide = null;
  }

  connectedCallback() {
    // Wait for Splide to load
    if (typeof Splide === 'undefined') {
      setTimeout(() => this.connectedCallback(), 100);
      return;
    }
    
    this.initCarousel();
  }

  initCarousel() {
    const carousel = this.querySelector('[data-cards-carousel]');
    if (!carousel) return;

    // Initialize Splide with fixed width slides
    this.splide = new Splide(carousel, {
      type: 'loop',
      autoWidth: true,
      perMove: 1,
      gap: '12px',
      padding: '3rem',
      pagination: true,
      arrows: false,
      focus: 'center',
      trimSpace: false,
      breakpoints: {
        768: {
          autoWidth: false,
          perPage: 1.5,
          gap: '20px',
          padding: {
            left: '60px',
            right: '60px'
          },
          focus: 'center'
        }
      }
    });

    this.splide.mount();
  }

  disconnectedCallback() {
    if (this.splide) {
      this.splide.destroy();
    }
  }
}

// Define the custom element
if (!customElements.get('cards-carousel-component')) {
  customElements.define('cards-carousel-component', CardsCarouselComponent);
}